export const remainingPercent = (usagePercent: number | null): number | null =>
  usagePercent === null ? null : Math.min(100, Math.max(0, 100 - usagePercent))
